import DelayRangeFilter from 'components/Billing/DelayRangeFilter';
import { buildAlertIdOverride } from 'components/Billing/alertAction';
import SummaryCards from 'components/Billing/SummaryCards';
import { buildBillingColumns } from 'components/Billing/columns';
import { buildHistoryOverride } from 'components/Billing/historyAction';
import { buildRenegotiationOverride } from 'components/Billing/renegotiationTag';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import useBillingList from 'hooks/useBillingList';
import { useContext, useMemo } from 'react';
import { BILLING_QUERIES, buildCards } from 'utils/billing';

// Segundo degrau da esteira: 31 a 60 dias de atraso. O recorte vem da query
// (BILLING_QUERIES.recuperacao) — o front nao reclassifica nada.
export default function BillingRecuperacao() {
  const { user, setModal } = useContext(CoreContext);
  const {
    loading,
    visibleRows,
    indicators,
    delayFrom,
    setDelayFrom,
    delayTo,
    setDelayTo,
    clearDelay,
    criticalOnly,
    toggleCritical,
    reload,
  } = useBillingList({ query: BILLING_QUERIES.recuperacao });

  const columns = useMemo(
    () =>
      buildBillingColumns(
        // Mesmas colunas da Cobranca.
        [
          'id',
          'contrato',
          'data_emissao',
          'banco',
          'distributor',
          'integrator',
          'customer',
          'telefone',
          'parcela',
          'valor_parcelas',
          'data_vencimento',
          'dias_atraso',
          'ultima_tentativa',
          'historico',
        ],
        {
          user,
          overrides: {
            ...buildAlertIdOverride({ setModal, reload }),
            ...buildRenegotiationOverride(),
            ...buildHistoryOverride({ setModal, reload }),
          },
        }
      ),
    [user, setModal, reload]
  );

  const cards = buildCards(indicators, {
    onToggleCritical: toggleCritical,
    criticalActive: criticalOnly,
  });

  return (
    <ContainerAuthenticated>
      <TableWrapper
        title="Recuperação"
        search
        filters={
          <DelayRangeFilter
            from={delayFrom}
            to={delayTo}
            onChangeFrom={setDelayFrom}
            onChangeTo={setDelayTo}
            onClear={clearDelay}
          />
        }
      >
        <SummaryCards cards={cards} />
        <BasicTable
          loading={loading}
          columns={columns}
          rows={visibleRows}
          groupBy="id"
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
